import { parseSafeHtml } from "../../utils/sanitizeHtml";
import { parseLegalHtml } from "../../utils/docContent";
import { usePageMeta } from "../../lib/usePageMeta";
import "./DocPage.scss";

const Terms = ({ i18n, terms, termsUrdu }) => {
  const isUrdu = i18n.languages[0] === "urdu";
  const raw = isUrdu ? termsUrdu || terms : terms;
  const { lastUpdated, content } = parseLegalHtml(raw);

  usePageMeta({
    title: "PkPlots | Terms of use",
    description: "Terms of use",
    canonical: "/terms",
  });

  return (
    <>
      <div className={`doc-page ${isUrdu ? "doc-page--rtl" : ""}`}>
        <header className='doc-page__hero'>
          <div className='doc-page__hero-inner'>
            <h1 className='doc-page__title'>
              {isUrdu ? "استعمال کی شرائط" : "Terms of Use"}
            </h1>
            <p className='doc-page__subtitle'>
              {isUrdu
                ? "PkPlots استعمال کرنے کے لیے شرائط و ضوابط۔"
                : "The terms that govern your use of PkPlots."}
            </p>
            {lastUpdated && (
              <div className='doc-page__meta'>
                <i className='bx bx-time-five' aria-hidden='true'></i>
                <span>
                  {isUrdu ? "آخری اپ ڈیٹ: " : "Last updated: "}
                  {lastUpdated}
                </span>
              </div>
            )}
          </div>
        </header>

        <div className='doc-page__body'>
          <div className='doc-page__content'>{parseSafeHtml(content)}</div>
        </div>
      </div>
    </>
  );
};

export default Terms;
